import { Injectable } from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';

import { AuthService } from './auth.service';
import {MatDialog} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState} from '../store/app.states';
import {KeepAliveService} from './keep-alive.service';


@Injectable()
export class AuthGuardService implements CanActivate {

  isAuthenticated: boolean;
  getAuthState: Observable<any>;

  constructor(public authService: AuthService,
              public router: Router,
              public dialog: MatDialog,
              private keepAliveService: KeepAliveService,
              private store: Store<AppState>) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getAuthState.subscribe(state => {
      this.isAuthenticated = state.isAuthenticated;
    });
  }

  canActivate(route: ActivatedRouteSnapshot, stateSnapshot: RouterStateSnapshot): boolean {

    if (!this.authService.getToken() && !this.isAuthenticated) {
      if (stateSnapshot.url.includes('questionnaire-compile')) {
        this.router.navigate(['login'], {queryParams: {returnUrl: stateSnapshot.url}});
      } else {
        this.router.navigate(['login']);
      }
      return false;
    }

    if (this.authService.expired()) {
      if (stateSnapshot.url.includes('questionnaire-compile')) {
        this.router.navigate(['login'], {queryParams: {returnUrl: stateSnapshot.url}});
      } else {
        this.router.navigate(['login']);
      }
      return false;
    }

    return true;
  }

}
